// BranchDropdownMenu.tsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { BranchDropdownMenuProps } from "../types/branch";

const BranchDropdownMenu: React.FC<BranchDropdownMenuProps> = ({ branchId, onEdit, onDelete, showDeletedBranches }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  // for <Menu onClose>
  const handleMenuClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
    setAnchorEl(null);
  };

  // for clicks inside menu items
  const handleItemClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!showDeletedBranches) {
      onEdit();
      handleItemClose();
    }
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!showDeletedBranches) {
      onDelete();
      handleItemClose();
    }
  };

  return (
    <>
      <IconButton aria-label="more" aria-controls={`branch-menu-${branchId}`} aria-haspopup="true" size="small" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        id={`branch-menu-${branchId}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleEdit} disabled={showDeletedBranches}> Edit </MenuItem>
        <MenuItem onClick={handleDelete} disabled={showDeletedBranches}> Delete </MenuItem>
      </Menu>
    </>
  );
};

export default BranchDropdownMenu;
